import { TabInfo } from '@core/models/tab';

export class TabUtility {
  constructor(public tabs: Array<TabInfo>) {}

  public IsTabActive(name: string): boolean {
    return this.tabs.find((t) => t.name === name).isActive;
  }

  public IsTabComplete(name: string): boolean {
    return this.tabs.find((t) => t.name === name).isComplete;
  }

  public IsTabApprove(name: string): boolean {
    return this.tabs.find((t) => t.name === name).isApprove;
  }

  public IsTabPending(name: string): boolean {
    return this.tabs.find((t) => t.name === name).isPending;
  }

  public IsTabTejected(name: string): boolean {
    return this.tabs.find((t) => t.name === name).isRejected;
  }

  public ActiveTab(name: string): void {
    this.tabs.forEach((tab) => {
      if (tab.name === name) {
        tab.isActive = true;
      } else {
        tab.isActive = false;
      }
    });
  }

  public CompleteTab(name: string): void {
    this.tabs.find((t) => t.name === name).isComplete = true;
  }

  public ApproveTab(name: string): void {
    this.tabs.find((t) => t.name === name).isApprove = true;
    this.tabs.find((t) => t.name === name).isPending = false;
  }

  public PendingTab(name: string): void {
    this.tabs.find((t) => t.name === name).isPending = true;
    this.tabs.find((t) => t.name === name).isApprove = false;
  }

  public RejectTab(name: string): void {
    this.tabs.find((t) => t.name === name).isRejected = true;
  }

  public ResetTab(name: string): void {
    const tab = this.tabs.find((t) => t.name === name);

    if (tab) {
      tab.isApprove = false;
      tab.isPending = false;
      tab.isRejected = false;
    }
  }
}
